import { useTheme } from "@/utils/theme-context";
import { NavLink, Outlet } from "react-router-dom";

const AccountPage = () => {
  const { theme } = useTheme();

  return (
    <div className="page">
      <div className="wrapper">
        <div className="page-navigation">
          <NavLink
            to="/account/general"
            className={({ isActive }) =>
              `${
                isActive
                  ? `page-navigation__item--active page-navigation__item--active--${theme}`
                  : ""
              } 
    page-navigation__item`
            }
          >
            <p className="page-navigation__item__index">1</p>
            Аккаунт
          </NavLink>
        </div>
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
